export default {
    ALLOWED_FILTER_ATTRIBUTE_CODES: [
        'price',
        'material_swatch',
        'kolor3_swatch',
        'kolor_emalii_swatch',
    ]
}